// frontend/src/auth/PermisoRoute.js
import React from 'react';
import { useAuth } from './AuthContext';
import { Navigate } from 'react-router-dom';

// Guard de ruta genérico por permiso (ver auth/roles.js), para no tener que crear
// un componente "XxxRoute" nuevo cada vez que un rol nuevo necesita acceso a una
// pantalla ya existente. Acepta uno o varios permisos: con varios, alcanza con
// tener al menos uno (mismo criterio "OR" que usa NavegacionLateral para secciones).
const PermisoRoute = ({ permiso, children }) => {
    const { puede } = useAuth();

    const permisos = Array.isArray(permiso) ? permiso : [permiso];
    const tieneAcceso = permisos.some((p) => puede(p));

    if (!tieneAcceso) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

export default PermisoRoute;
